import {
	faCalendarCircleUser,
	faFile,
	faHandHoldingBox,
	faRepeat,
	faSatelliteDish,
	faSparkles,
	faUserMagnifyingGlass,
} from "@fortawesome/pro-regular-svg-icons";

import { t } from "i18next";

import { FunctionComponent } from "react";

import GoogleMapsIcon from "@assets/icons/google-maps.svg?url";

import LinkedinIcon from "@assets/icons/linkedin.svg?url";

import { Icon } from "@/components";
import { ListSourceType } from "@/enum/list.enum";
import { SvgIcon } from "@/components/Icon/SvgIcon";
import { ReactComponent as UserCircle } from "@assets/icons/inbox/user-circle.svg";

export interface ListSourceTypeProps {
	sourceType: ListSourceType;
	type?: "text" | "icon";
	size?: "default" | "compact";
}
export const ListSourceTypeElem: FunctionComponent<ListSourceTypeProps> = ({
	sourceType,
	type = "text",
	size = "default",
}) => {
	const wrapperClass =
		size === "compact"
			? "flex h-8 items-center bg-inactive-item text-gray-700 rounded-md px-2 text-xs"
			: "flex items-center bg-inactive-item text-gray-700 rounded-[10px] p-2";
	const iconClass = size === "compact" ? "w-3.5 h-3.5 mr-1" : "w-[18px] h-[18px] mr-1";
	const imgClass = size === "compact" ? "h-3.5 mr-1 rounded" : "h-[18px] mr-1 rounded";
	const textClass = size === "compact" ? "text-xs" : "text-sm";

	return (
		<>
			{sourceType === ListSourceType.EMPTY ? (
				<div className={wrapperClass}>
					<Icon className={iconClass} icon={faFile} />
					{type === "text" && <span className={textClass}>Empty</span>}
				</div>
			) : (
				<></>
			)}
			{sourceType === ListSourceType.LI_EVENTS ? (
				<div className={wrapperClass}>
					<img alt="LinkedinIcon" className={imgClass} src={LinkedinIcon} />
					{type === "text" && <span className={textClass}>Events</span>}
				</div>
			) : (
				<></>
			)}
			{sourceType === ListSourceType.LI_PEOPLE ? (
				<div className={wrapperClass}>
					<img alt="LinkedinIcon" className={imgClass} src={LinkedinIcon} />
					{type === "text" && <span className={textClass}>People</span>}
				</div>
			) : (
				<></>
			)}
			{sourceType === ListSourceType.MAPS ? (
				<div className={wrapperClass}>
					<img alt="LinkedinIcon" className={imgClass} src={GoogleMapsIcon} />
					{type === "text" && <span className={textClass}>Google Maps</span>}
				</div>
			) : (
				<></>
			)}
			{sourceType === ListSourceType.LI_COMPANY_ACTIVITY ? (
				<div className={wrapperClass}>
					<img alt="LinkedinIcon" className={imgClass} src={LinkedinIcon} />
					{type === "text" && <span className={textClass}>Company Activity</span>}
				</div>
			) : (
				<></>
			)}
			{sourceType === ListSourceType.LI_PROFILE_VISITS ? (
				<div className={wrapperClass}>
					<img alt="LinkedinIcon" className={imgClass} src={LinkedinIcon} />
					{type === "text" && <span className={textClass}>Profile Visits</span>}
				</div>
			) : (
				<></>
			)}
			{sourceType === ListSourceType.LI_PROFILE ? (
				<div className={wrapperClass}>
					<img alt="LinkedinIcon" className={imgClass} src={LinkedinIcon} />
					{type === "text" && <span className={textClass}>Custom Signal Tracker</span>}
				</div>
			) : (
				<></>
			)}
			{sourceType === ListSourceType.LI_POST ? (
				<div className={wrapperClass}>
					<img alt="LinkedinIcon" className={imgClass} src={LinkedinIcon} />
					{type === "text" && <span className={textClass}>Engagement</span>}
				</div>
			) : (
				<></>
			)}
			{sourceType === ListSourceType.LI_SN ? (
				<div className={wrapperClass}>
					<img alt="LinkedinIcon" className={imgClass} src={LinkedinIcon} />
					{type === "text" && <span className={textClass}>Sales Navigator</span>}
				</div>
			) : (
				<></>
			)}
			{sourceType === ListSourceType.CUSTOM_EVENTS ? (
				<div className={wrapperClass}>
					<Icon className={iconClass} icon={faCalendarCircleUser} />
					{type === "text" && <span className={textClass}>Website</span>}
				</div>
			) : (
				<></>
			)}
			{sourceType === ListSourceType.CSV_ENRICHMENTS ? (
				<div className={wrapperClass}>
					<Icon className={iconClass} icon={faFile} />
					{type === "text" && <span className={textClass}>XLSX File</span>}
				</div>
			) : (
				<></>
			)}
			{sourceType === ListSourceType.JOBS ? (
				<div className={wrapperClass}>
					<Icon className={iconClass} icon={faHandHoldingBox} />
					{type === "text" && <span className={textClass}>{t(`sidebar.jobs`)}</span>}
				</div>
			) : (
				<></>
			)}
			{sourceType === ListSourceType.JOB_CHANGE ? (
				<div className={wrapperClass}>
					<Icon className={iconClass} icon={faUserMagnifyingGlass} />
					{type === "text" && <span className={textClass}>{t(`list.sourceTypes.JOB_CHANGE`)}</span>}
				</div>
			) : (
				<></>
			)}
			{sourceType === ListSourceType.PARALLEL_AI ? (
				<div className={wrapperClass}>
					<Icon className={iconClass} icon={faSparkles} />
					{type === "text" && <span className={textClass}>{t(`sidebar.parallelAi`)}</span>}
				</div>
			) : (
				<></>
			)}
			{sourceType === ListSourceType.TRACKER ? (
				<div className={wrapperClass}>
					<Icon className={iconClass} icon={faSatelliteDish} />
					{type === "text" && <span className={textClass}>{t(`list.sourceTypes.TRACKER`)}</span>}
				</div>
			) : (
				<></>
			)}
			{sourceType === ListSourceType.SMART_LIST ? (
				<div className={wrapperClass}>
					<Icon className={iconClass} icon={faRepeat} />
					{type === "text" && <span className={textClass}>{t(`list.sourceTypes.SMART_LIST`)}</span>}
				</div>
			) : (
				<></>
			)}
		</>
	);
};
